import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import DatasetSelectTrend from '../common/select-filters/DatasetSelectTrend';
import HealthAwareness from '../common/charts/HealthAwareness';
import TrendDiagram from '../common/charts/TrendDiagram';
import Methodology from '../common/Methodology';
import Related from '../common/Related.js';

import { oshCulture } from '../../model/subMenuTabs';

const OSHCulture = props => {

	let selected = '';
	for (let i = 0; i < oshCulture.length; i++)
	{
		if (props.indicator == oshCulture[i].url)
		{
			selected = oshCulture[i];
		}
	}
	
	const currentPath = '/working-conditions-preventions/osh-culture/';
	const chartDimension = window.innerWidth > 768 ? 'column' : 'bar';

	const [selectedTab, setSelectedTab] = useState(selected);
	const [chartLegend, setChartLegend] = useState('');
	const [isTrend, setIsTrend] = useState(false);
	const [selectedAnswer, setSelectedAnswer] = useState(undefined);
	const [selectedDataset1, setSelectedDataset1] = useState(undefined);
	const [selectedDataset2, setSelectedDataset2] = useState(undefined);
	const [selectedSortBy, setSelectedSortBy] = useState(false);
	const [selectedSurvey, setSelectedSurvey] = useState(undefined);

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22012 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	}, [])

	useEffect(() => {
		for (let i = 0; i < oshCulture.length; i++)
		{
			if (props.indicator == oshCulture[i].url)
			{
				setSelectedTab(oshCulture[i]);				
			}
		}
	}, [props.indicator])

	const callbackSelectedTab = (callback) => {
		let selected = oshCulture.find((tab) => tab.url == callback);

		if (selected != null)
		{
			setSelectedTab(selected);
			setIsTrend(false);
			setSelectedDataset1(null);
		}
	}

	const callbackChartLegend = (legend) => {
		setChartLegend(legend);
	}
	
    const handleTrendButton = () => {
		setIsTrend(!isTrend);
    }

    const handleSortButton = () => {
		setSelectedSortBy(!selectedSortBy);
    }

    const handleAnswerChange = (callback) => {
        setSelectedAnswer(callback);
    }

    const handleDatasetChange1 = (dataset, indicator) => {
		setSelectedDataset1(dataset);
    }

    const handleDatasetChange2 = (dataset, indicator) => {
        setSelectedDataset2(dataset);
    }

    const callbackSelectedSurvey = (callback) => {
		setSelectedSurvey(callback);
    }
	
	return(
		<div className="osh-culture">
			<AdviceSection literals={ props.literals } section={["working-conditions-preventions","osh-culture"]} methodologyData={{section: 'working-conditions-preventions', subsection: 'OSH culture and health awareness', indicator: 63}} />

			<SubMenuTabs 
				literals={ props.literals } 
				callbackSelectedTab={ callbackSelectedTab } 
				subMenuTabs={ oshCulture }
				selectedTab={ selectedTab.url }
				locationPath={ currentPath }
			/>

			<div className='line background-main-light'></div>

			<DatasetSelectTrend 
				literals={ props.literals }
				chartType={ selectedTab.chartType }
				handleAnswerChange={ handleAnswerChange }
				handleDatasetChange1={ (e) => handleDatasetChange1(e) }
				handleDatasetChange2={ (e) => handleDatasetChange2(e) }
				callbackSelectedSurvey={ callbackSelectedSurvey }
				selectedIndicator={ selectedSurvey }
				showAnswerSelect={ isTrend }
			/>

			<div className="line background-main-light"></div>

			<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
				<div className="card--block--chart with-filters" >
					<div className='card--btn-wrapper'>
						<div className="select-filter-chart-wrapper">                                
							{ !isTrend && <div className="switch--button">
								<input type="checkbox" name="switch-button" id="switch-label" 
								className="switch--button-checkbox" defaultChecked={ selectedSortBy } />
								<label htmlFor="switch-label" className="switch--button-label" onClick={ handleSortButton }></label>
								<label htmlFor="switch-label" className="text-label" onClick={ handleSortButton }>{ props.literals["L20341"] }</label>
							</div>}
						</div>
						{ selectedTab.url != "health-and-safety-discussed" &&
						 selectedTab.url != "use-of-personal-protective-equipment" && (
							<div className='btn-trend-container'>
								<a className="btn-default btn-main-color ng-binding btn-trend" onClick={ handleTrendButton }>
									{ !isTrend ? props.literals["L20287"] : props.literals["L20311"] }
								</a>
							</div>
						)}                            
					</div>
					<div className="chart--block">
						{ oshCulture.map((tab) => {
							if (tab.url == selectedTab.url) {
								return (
									!isTrend ? (<div key={tab.literalTab}>
										<HealthAwareness
											literals={ props.literals }
											tabIndicator={ tab.literalTab }
											chartType={ tab.chartType }
											colors={ ['#7b7b7d', '#cbe2e3','#f6a400'] }
											percentage={ true }
											callbackLegend={ callbackChartLegend }
											selectedSortBy={ selectedSortBy }
											selectedDataset={ selectedDataset1 }
										/>
									</div>) : 
									(<div key={tab.literalTab}>
										<TrendDiagram
											literals={ props.literals }
											tabIndicator={ tab.literalTab }
											chartType={ tab.chartType }
											selectedAnswer={ selectedAnswer }
											selectedDataset1={ selectedDataset1 }
											selectedDataset2={ selectedDataset2 }
											colors={ ['#f6a300', '#cbe2e3'] }
											type={ chartDimension }
										/>
									</div>)
								)
							}
						})}
					</div>
				</div>

				<div className="chart-legend">
					{ ReactHtmlParser( props.literals[`L${ chartLegend }`] ) }
				</div>

			</div>
			<Methodology literals={ props.literals } section={'OSH culture and health awareness'} indicator={selectedTab.chartType[0].chartIndicator} />

			<Related literals={ props.literals } section={["working-conditions-preventions","osh-culture", selectedTab.url]} />
		</div>
	)
}
OSHCulture.displayName = 'OSHCulture';
export default OSHCulture;